import { QUERY_KEYS } from 'api/query-keys';
import { companyService } from 'ogp/services';
import { useQuery } from 'react-query';
import { CompanyDetailAndJobGroups } from '@types';

export const useGetCompanyDetailAndJobGroups = () => {
  const queryFn = async () => await companyService.getCompanyDetailAndJobGroups();

  return useQuery<Promise<CompanyDetailAndJobGroups>, Error, CompanyDetailAndJobGroups>(
    QUERY_KEYS.ownCompanyDetailAndJobGroups(),
    queryFn
  );
};
